import closeIcon from "@ms/close.svg?raw";
import { Icon } from "./Icon";
import "./CloseButton.css";
import type { ParentComponent } from "solid-js";

type Props = {
	onClick?: () => void;
	class?: string;
	"aria-label"?: string;
};

/**
 * Button with close icon for dismissing panels or modals.
 *
 * [Design System →](http://localhost:5174/component/Icon)
 */
export const CloseButton: ParentComponent<Props> = (props) => {
	return (
		<button
			type="button"
			class={`gvtui-close-button icon ${props.class ?? ""}`}
			tabIndex={0}
			onClick={props.onClick}
			aria-label={props["aria-label"] ?? "Close"}
		>
			<Icon icon={closeIcon} />
		</button>
	);
};
